var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$_.get(_vm.activity, "actorUser.name") || "Bilinmeyen Kullanıcı"
        ) +
          ' kullanıcısı "' +
          _vm._s(
            _vm.$_.get(_vm.activity, "payload.taskTitle") || "Bilinmeyen Görev"
          ) +
          '" adlı görevi arşivden geri çıkardı.'
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }